import axiosInstance from "services/AuthHeader";
import { toQuestionnaireResponse } from "services/checkIn/questionnaire-response";

export async function fetchStatus() {
  const httpResponse = await axiosInstance({
    method: "GET",
    url: `/api/check-in?asOf=${new Date().toISOString()}`
  })
  return httpResponse.data
}

export async function pushStatus(patientId, {
  answers,
  answersResponseId,
  answersETag,
  hiddenCards,
  hiddenCardsResponseId,
  hiddenCardsETag,
  submitted = false
}) {
  const request = {
    resourceType: "Bundle",
    type: "transaction",
    entry: [{
      resource: toQuestionnaireResponse(answers, {
        questionnaire: "Questionnaire/check-in-survey",
        subject: `Patient/${patientId}`,
        status: submitted && "completed",
        authored: new Date().toISOString()
      }),
      request: {
        method: "PUT",
        url: `QuestionnaireResponse/${answersResponseId}`,
        ifMatch: answersETag
      }
    }, {
      resource: toQuestionnaireResponse(hiddenCards, {
        questionnaire: "Questionnaire/hidden-cards",
        subject: `Patient/${patientId}`,
        status: "completed",
      }),
      request: {
        method: "PUT",
        url: `QuestionnaireResponse/${hiddenCardsResponseId}`,
        ifMatch: hiddenCardsETag
      }
    }]
  }

  const httpResponse = await axiosInstance({
    method: "POST",
    url: "/fhir",
    data: request,
    headers: { "Prefer": "return=representation" }
  })
  return httpResponse.data
}